import React, { useEffect, useMemo } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AccordionFullTable, AddCircleBlue, CustomDelete } from 'components';
import { FindSuccessItem, PermissionList, RolePermission, sortListByKey, useModal } from 'utils';
import { clientActions, fundingSourceActions, httpRequestsOnSuccessActions, supervisionActions } from 'store';
import { AddEnrollment } from '../../clientModals';
import { ClientPayerInsuredInfo, clientPayerTableInfo } from './constants';

const TERMINATE_CLIENT_ENROLLMENT = 'TERMINATE_CLIENT_ENROLLMENT';
const CREATE_ACTION_TYPE = 'CREATE_CLIENT_ENROLLMENT';
const EDIT_ACTION_TYPE = 'EDIT_CLIENT_ENROLLMENT';

export const ClientEnrollment = ({}) => {
    const { open, close } = useModal();
    const dispatch = useDispatch();
    const enrolments = useSelector((state) => state.client.clientEnrollment);
    const client = useSelector((state) => state.client.clientItemInfo);
    const supervisionSummary = useSelector((state) => state.supervision.supervisionSummary);
    const createSuccess = FindSuccessItem(CREATE_ACTION_TYPE);
    const editSuccess = FindSuccessItem(EDIT_ACTION_TYPE);
    const navigate = useNavigate();
    const location = useLocation();
    const pushInfo = location?.state;
    const params = useParams();

    useEffect(() => {
        dispatch(fundingSourceActions.getFundingSource({ status: 'ACTIVE' }));
        if (params?.id) {
            dispatch(supervisionActions.getSupervisionSummary({ clientId: params.id }));
        }
    }, []);

    useEffect(() => {
        if (createSuccess || editSuccess) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(CREATE_ACTION_TYPE));
            getEnrollments('noLoad');
            close();
        }
        if (editSuccess) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(EDIT_ACTION_TYPE));
            getEnrollments('noLoad');
            close();
        }
    }, [createSuccess, editSuccess]);

    useEffect(() => {
        if (RolePermission([PermissionList.CLIENT_ENROLLMENT_MANAGE?.code, PermissionList.CLIENT_ENROLLMENT_READ?.code])) {
            getEnrollments();
        }
    }, [pushInfo]);

    const enrichedEnrollments = useMemo(() => {
        if (!enrolments) return [];
        const items = supervisionSummary?.items || [];
        const supervisionMap = {};
        items.forEach((item) => {
            supervisionMap[item.payer.id] = item;
        });
        return sortListByKey(enrolments, 'payerName').map((enrollment) => ({
            ...enrollment,
            supervisionCompliance: supervisionMap[enrollment.payerId] || null,
        }));
    }, [enrolments, supervisionSummary]);

    const getEnrollments = (load) => {
        const sendParams = {
            type: pushInfo?.type,
        };
        if (RolePermission([PermissionList.CLIENT_ENROLLMENT_MANAGE?.code, PermissionList.CLIENT_ENROLLMENT_READ?.code])) {
            dispatch(clientActions.getClientsEnrollment(params?.id, sendParams, load));
        }
    };

    const handleEdit = (item, name) => {
        if (name === 'edit') {
            open(<AddEnrollment info={item} />);
        }
        if (name === 'inactivate') {
            open(
                <CustomDelete
                    info="Inactivate Payer"
                    text="Are you sure you want to inactivate this payer ?"
                    handleDel={() => dispatch(clientActions.terminateClientEnrollment(client?.id, item?.id))}
                    actionType={TERMINATE_CLIENT_ENROLLMENT}
                    innerText={'Inactivate'}
                    afterSuccess={() => getEnrollments('noLoad')}
                />
            );
        }
    };

    return (
        <div>
            {RolePermission([PermissionList.CLIENT_ENROLLMENT_MANAGE?.code]) && (
                <div className="header-action-btn">
                    <AddCircleBlue text={'Add Payer'} handleClick={() => open(<AddEnrollment />)} />
                </div>
            )}
            <AccordionFullTable
                tableInfo={clientPayerTableInfo(handleEdit)}
                list={enrichedEnrollments}
                margin={'0'}
                renderAccordionDetails={(item) => <ClientPayerInsuredInfo enrollment={item} />}
            />
        </div>
    );
};
